(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime/helpers/createClass", "@babel/runtime/helpers/inheritsLoose", "lodash/assign", "../../../core/ua", "../shared/Deferrable", "../shared/getHostAndMethod", "../util", "./createWxError", "./jsApiList", "./wxMock"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime/helpers/createClass"), require("@babel/runtime/helpers/inheritsLoose"), require("lodash/assign"), require("../../../core/ua"), require("../shared/Deferrable"), require("../shared/getHostAndMethod"), require("../util"), require("./createWxError"), require("./jsApiList"), require("./wxMock"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.createClass, global.inheritsLoose, global.assign, global.ua, global.Deferrable, global.getHostAndMethod, global.util, global.createWxError, global.jsApiList, global.wxMock);
    global.WechatSdk = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _createClass2, _inheritsLoose2, _assign, _ua, _Deferrable2, _getHostAndMethod2, _util, _createWxError, _jsApiList, _wxMock) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

  _exports.__esModule = true;
  _exports["default"] = void 0;
  _createClass2 = _interopRequireDefault(_createClass2);
  _inheritsLoose2 = _interopRequireDefault(_inheritsLoose2);
  _assign = _interopRequireDefault(_assign);
  _Deferrable2 = _interopRequireDefault(_Deferrable2);
  _getHostAndMethod2 = _interopRequireDefault(_getHostAndMethod2);
  _createWxError = _interopRequireDefault(_createWxError);
  _jsApiList = _interopRequireDefault(_jsApiList);
  _wxMock = _interopRequireDefault(_wxMock);

  function callWxApi(callback) {
    if (process.env.NODE_ENV === "development") {
      return callback();
    }

    if (typeof window.WeixinJSBridge === "undefined") {
      if (document.addEventListener) {
        document.addEventListener("WeixinJSBridgeReady", callback, false);
      } else if (document.attachEvent) {
        document.attachEvent("WeixinJSBridgeReady", callback);
        document.attachEvent("onWeixinJSBridgeReady", callback);
      }
    } else {
      callback();
    }
  }

  function checkMethodAndArgs_(method) {
    if (typeof method !== "string") {
      throw new TypeError("Invalid argument, method name must be a string");
    }

    if (method === "ready" || method === "error") {
      throw new Error("Forbiddend method call");
    }
  }

  function patch(obj, methodName, fn) {
    if (!obj) {
      obj = {};
    }

    var old = obj[methodName];

    obj[methodName] = function (args) {
      // call old
      if (typeof old === "function") {
        // eslint-disable-next-line
        old.apply(this, arguments);
      } // call fn.


      fn(args);
    };

    return obj;
  }
  /**
   * 是否可以忽略路由变化。
   * ios 下可以忽略路由变化的。
   * 企业微信下（即使是 ios）不能忽略路由变化。
   */


  var isOmitRouteChange = function isOmitRouteChange() {
    return (0, _util.isIOS)() && !_ua.isWxwork;
  };

  var WechatSdkInternal = /*#__PURE__*/function (_Deferrable) {
    (0, _inheritsLoose2["default"])(WechatSdkInternal, _Deferrable);

    function WechatSdkInternal(options) {
      var _this;

      _this = _Deferrable.call(this) || this;
      _this.options = void 0;
      _this.lastTarget_ = "";
      _this.ready_ = false;
      _this.firstTarget_ = "";
      _this.isConfiguring_ = false;
      _this.options = (0, _assign["default"])({}, {
        jsApiList: _jsApiList["default"]
      }, options);
      return _this;
    }

    var _proto = WechatSdkInternal.prototype;

    _proto.ready = function ready() {
      var _this2 = this;

      if (!this.wx) {
        return Promise.reject(new Error("WeChat SDK is not loaded"));
      }

      return new Promise(function (resolve, reject) {
        _this2.wx.ready(function () {
          _this2.ready_ = true;
          resolve();
        });

        _this2.wx.error(function (err) {
          _this2.ready_ = false;
          reject((0, _createWxError["default"])(err));
        });
      });
    };

    _proto.config = function
      /* ProviderApiOptions?: ProviderApiOptions */
    config() {
      var _this3 = this;

      if (!this.wx) {
        var err = new Error("WeChat SDK is not loaded");
        this.consumeDeferTasks(err);
        return Promise.reject(err);
      }

      if (!this.options.configGetter) {
        var _err = new Error("invalid options, wxConfigGetter is required");

        this.consumeDeferTasks(_err);
        throw _err;
      }

      var target = this.options.configUrlGetter();

      if (isOmitRouteChange() && this.firstTarget_) {
        target = this.firstTarget_;

        if (this.isReady) {
          console.log("isReady, just resolve");
          this.consumeDeferTasks();
          return Promise.resolve();
        } else if (this.isConfiguring_) {
          return new Promise(function (resolve, reject) {
            _this3.pushTask("config", resolve, reject);
          });
        }
      }

      if (!this.firstTarget_) {
        this.firstTarget_ = target;
      }

      if (this.isConfiguring_ && this.lastTarget_ === target) {
        // previous config is ongoing.
        return new Promise(function (resolve, reject) {
          _this3.pushTask("config", resolve, reject);
        });
      } else if (this.isConfiguring_) {
        // abort last config.
        this.removeTask("config");
      }

      this.isConfiguring_ = true;
      this.lastTarget_ = target;
      return new Promise(function (resolve, reject) {
        _this3.options.configGetter(target).then(function (configOptions) {
          _this3.doConfig_(configOptions).then(resolve, reject);
        }, reject);
      });
    };

    _proto.doConfig_ = function doConfig_(configOptions) {
      var _this4 = this;

      this.ready_ = false;
      return new Promise(function (resolve, reject) {
        var options = Object.assign({}, configOptions, {
          debug: false,
          jsApiList: _this4.options.jsApiList
        });
        callWxApi(function () {
          _this4.wx.config(options);

          _this4.ready().then(function () {
            _this4.isConfiguring_ = false;

            _this4.consumeDeferTasks();

            resolve();
          }, function (err) {
            console.log("wx: err", err);
            _this4.isConfiguring_ = false;

            _this4.consumeDeferTasks(err);

            reject(err);
          });
        });
      });
    };

    _proto.exec = function exec() {
      var _this5 = this;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var method = args.shift(); // eslint-disable-next-line

      console.log("exec: " + method, args);
      checkMethodAndArgs_(method);

      if (this.isReady) {
        return this.run_(method, args);
      } else {
        return new Promise(function (resolve, reject) {
          _this5.pushTask(method, function () {
            // eslint-disable-next-line
            _this5.run_(method, args).then(resolve, reject);
          }, function (err) {
            reject(err);
          });

          _this5.config();
        });
      }
    }
    /**
     * Run command in sync, no matter is ready or not.
     */
    ;

    _proto.run = function run() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      var method = args.shift(); // eslint-disable-next-line

      console.log("run: " + method, args);
      checkMethodAndArgs_(method);
      return this.run_(method, args);
    };

    _proto.run_ = function run_(method, args) {
      var _this6 = this;

      var host = this.wx;

      if (method.indexOf(".") !== -1) {
        // eg: miniProgram.getEnv
        // skd.exec('miniProgram.getEnv', {})
        var _getHostAndMethod = (0, _getHostAndMethod2["default"])(this.wx, method),
            host_ = _getHostAndMethod[0],
            method_ = _getHostAndMethod[1];

        host = host_;
        method = method_;
      }

      return new Promise(function (resolve, reject) {
        if (!_this6.wx) {
          return reject(new Error("no wx"));
        } // @ts-ignore


        if (typeof host[method] === "function") {
          var _host;

          var arg = (0, _assign["default"])({}, args.length ? args[0] : {});
          var addedCallback = true;
          arg = patch(arg || {}, "success", function (res) {
            // eslint-disable-next-line
            console.log(method + " resolved in success callback");
            return resolve(res);
          });
          arg = patch(arg || {}, "fail", function (e) {
            var message = "unknow error";

            if (e && typeof e.errMsg === "string") {
              message = e.errMsg;
            } // eslint-disable-next-line


            console.log("fail:", message);
            return reject(new Error(message));
          });

          if (Object.prototype.toString.call(arg) === "[object Object]") {
            args[0] = arg;
          } else {
            addedCallback = false;
          } // @ts-ignore


          (_host = host)[method].apply(_host, args); // no success|fail hook, just resolve it.


          if (!addedCallback) {
            return resolve(undefined);
          }
        } else {
          return reject(new Error("method not exists: " + method));
        }
      });
    };

    (0, _createClass2["default"])(WechatSdkInternal, [{
      key: "isReady",
      get: function get() {
        if (isOmitRouteChange() && this.firstTarget_ && this.ready_) {
          return true;
        }

        var target = this.options.configUrlGetter();
        return this.lastTarget_ === target && this.ready_;
      }
    }, {
      key: "wx",
      get: function get() {
        if (process.env.NODE_ENV === "development") {
          // @ts-ignore
          return _wxMock["default"];
        }

        return window.wx || window.jWeixin;
      }
    }]);
    return WechatSdkInternal;
  }(_Deferrable2["default"]);

  _exports["default"] = WechatSdkInternal;
});
//# sourceMappingURL=WechatSdk.js.map